import { render, staticRenderFns } from "./KVDR.vue?vue&type=template&id=5bf14b5c&scoped=true&"
import script from "./KVDR.vue?vue&type=script&lang=js&"
export * from "./KVDR.vue?vue&type=script&lang=js&"
import style0 from "./KVDR.vue?vue&type=style&index=0&id=5bf14b5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf14b5c",
  null
  
)

export default component.exports